import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
  },
}));

export default useStyles;
